import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "card"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_KpiSchedulerKpiCard = _resolveComponent("KpiSchedulerKpiCard")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_KpiSchedulerFiltersCard = _resolveComponent("KpiSchedulerFiltersCard")
  const _component_KnCron = _resolveComponent("KnCron")
  const _component_KpiSchedulerExecuteCard = _resolveComponent("KpiSchedulerExecuteCard")
  const _component_TabView = _resolveComponent("TabView")
  const _component_KpiSchedulerSaveDialog = _resolveComponent("KpiSchedulerSaveDialog")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-m-0" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(this.clone || this.id ? this.selectedSchedule.name : this.$t('kpi.kpiScheduler.newScheduler')), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.buttonDisabled,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveDialogVisible = true)),
          "data-test": "submit-button"
        }, null, 8, ["disabled"]),
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.closeTemplate,
          "data-test": "close-button"
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_TabView, { class: "tabview-custom" }, {
            default: _withCtx(() => [
              _createVNode(_component_TabPanel, null, {
                header: _withCtx(() => [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('common.kpi')), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_KpiSchedulerKpiCard, {
                    expired: _ctx.selectedSchedule.jobStatus === 'EXPIRED',
                    kpis: _ctx.selectedSchedule.kpis,
                    allKpiList: _ctx.kpiList,
                    onTouched: _ctx.setTouched,
                    onKpiAdded: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onKpiAdded($event))),
                    onKpiDeleted: _ctx.onKpiDeleted
                  }, null, 8, ["expired", "kpis", "allKpiList", "onTouched", "onKpiDeleted"])
                ]),
                _: 1
              }),
              _createVNode(_component_TabPanel, {
                disabled: Object.keys(this.formatedFilters).length === 0
              }, {
                header: _withCtx(() => [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('kpi.kpiScheduler.filters')), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_KpiSchedulerFiltersCard, {
                    formatedFilters: _ctx.formatedFilters,
                    placeholderType: _ctx.domainsKpiPlaceholderType,
                    temporalType: _ctx.domainsKpiPlaceholderFunction,
                    lovs: _ctx.lovs,
                    onTouched: _ctx.setTouched
                  }, null, 8, ["formatedFilters", "placeholderType", "temporalType", "lovs", "onTouched"])
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_TabPanel, null, {
                header: _withCtx(() => [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('kpi.kpiScheduler.frequency')), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_KnCron, {
                    frequency: _ctx.selectedSchedule.frequency,
                    onTouched: _ctx.setTouched,
                    onCronValid: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setCronValid($event)))
                  }, null, 8, ["frequency", "onTouched"])
                ]),
                _: 1
              }),
              _createVNode(_component_TabPanel, null, {
                header: _withCtx(() => [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('kpi.kpiScheduler.execute')), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_KpiSchedulerExecuteCard, {
                    selectedSchedule: _ctx.selectedSchedule,
                    onTouched: _ctx.setTouched
                  }, null, 8, ["selectedSchedule", "onTouched"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])),
    (_ctx.saveDialogVisible)
      ? (_openBlock(), _createBlock(_component_KpiSchedulerSaveDialog, {
          key: 2,
          schedulerName: _ctx.selectedSchedule.name,
          onSave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveScheduler($event))),
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveDialogVisible = false))
        }, null, 8, ["schedulerName"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      style: _ctx.kpiSchedulerTabViewDescriptor.errorDialog.style,
      modal: true,
      visible: _ctx.errorDialogVisible,
      header: _ctx.$t('common.toast.' + this.operation + 'Title'),
      class: "full-screen-dialog p-fluid kn-dialog--toolbar--primary error-dialog",
      closable: false,
      "data-test": "save-dialog"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--secondary",
          label: _ctx.$t('common.close'),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.errorMessage = null))
        }, null, 8, ["label"])
      ]),
      default: _withCtx(() => [
        _createVNode("p", null, _toDisplayString(_ctx.errorMessage), 1)
      ]),
      _: 1
    }, 8, ["style", "visible", "header"])
  ], 64))
}